import React from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
import Tooltip from "@material-ui/core/Tooltip";
import Fade from "@material-ui/core/Fade";
import Icon from "@mdi/react";
import {
  mdiMenu,
  mdiBackburger,
  mdiGithubFace,
  mdiBrightness4,
  mdiPrinter,
  mdiHome
} from "@mdi/js";
import Transition from "../Transition";
import Title from "../Title/Title";
import HeaderText from "./HeaderText";
import Pdf from "../../pdf/Karan More_Resume.pdf";
import Link from "../Link/Link";

export const getPath = open => (open ? mdiBackburger : mdiMenu);

export default function Header({
  open,
  toggleDrawer,
  togglePrefersColorScheme,
  theme
}) {
  let themeColor;

  if (theme === "LIGHT") {
    themeColor = "Toggle Dark";
  } else {
    themeColor = "Toggle Light";
  }
  return (
    <Transition in component={Fade} delay={337} timeout={775}>
      <AppBar position="sticky" color="primary" elevation={2}>
        <Toolbar>
          <Hidden lgUp>
            <IconButton
              edge="start"
              aria-label="open navigation drawer"
              onClick={toggleDrawer}
            >
              <Hidden smUp>
                <Icon path={getPath(open)} size={1} color="currentColor" />
              </Hidden>
              <Hidden xsDown>
                <Icon path={getPath(open)} size={1.125} color="currentColor" />
              </Hidden>
            </IconButton>
          </Hidden>
          <Hidden smUp>
            <Title variant="h6" color="textPrimary">
              <HeaderText />
            </Title>
          </Hidden>
          <Hidden xsDown>
            <Title variant="h5" color="textPrimary">
              <HeaderText />
            </Title>
          </Hidden>
          <Hidden xsDown>
            <Tooltip title="Home" placement="bottom">
              <Link to="/" style={{ textDecoration: "none" }}>
                <IconButton>
                  <Icon path={mdiHome} size={1.125} color="currentColor" />
                </IconButton>
              </Link>
            </Tooltip>

            <Tooltip title="Contributions" placement="bottom">
              <IconButton href="https://github.com/karan-more" target="_blank">
                <Icon path={mdiGithubFace} size={1.125} color="currentColor" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print resume" placement="bottom">
              <IconButton href={Pdf} target="_blank">
                <Icon path={mdiPrinter} size={1.125} color="currentColor" />
              </IconButton>
            </Tooltip>
          </Hidden>
          <Hidden smUp>
            <Tooltip title={themeColor} placement="bottom">
              <IconButton edge="end" onClick={togglePrefersColorScheme}>
                <Icon path={mdiBrightness4} size={1} color="currentColor" />
              </IconButton>
            </Tooltip>
          </Hidden>
          <Hidden xsDown>
            <Tooltip title={themeColor} placement="bottom">
              <IconButton onClick={togglePrefersColorScheme}>
                <Icon path={mdiBrightness4} size={1.25} color="currentColor" />
              </IconButton>
            </Tooltip>
          </Hidden>
        </Toolbar>
      </AppBar>
    </Transition>
  );
}

Header.propTypes = {
  open: PropTypes.bool.isRequired,
  toggleDrawer: PropTypes.func.isRequired,
  togglePrefersColorScheme: PropTypes.func.isRequired
};
